export default {
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
};
